import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "className", "children"];
import React from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from '@carnica/ui-kit';
import { ShowFilters } from "../../../../features/show-filters/ui";
import styles from "./styles.pcss";
var cnTitle = cnBem('title', styles);
export var Title = function Title(_ref) {
  var title = _ref.title,
    className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnTitle(null, [className])
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: cnTitle('side')
  }, children), /*#__PURE__*/React.createElement("div", {
    className: cnTitle('title')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cnTitle('header'),
    color: "primary-invert",
    variant: "body-medium"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: cnTitle('side')
  }, /*#__PURE__*/React.createElement(ShowFilters, null)));
};